// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"8":"editor","140":"email_verified","419":"wiki","542":"overview","884":"admin"}[chunkId] || chunkId) + "." + {"8":"4ecdf8a6","140":"e15c084f","155":"c034bed1","401":"a1239a80","419":"8ab4411a","433":"3fbdec7b","462":"f25bd573","542":"69edc5b9","601":"e0d4e692","884":"ad9113f5"}[chunkId] + ".js";
};